import React from 'react';
import { FormProvider } from 'react-hook-form';
import { DeviceChartSet, useChartSet, useChartSetForm } from 'components/features/DeviceChartView';
import ChartExplorerPageSearchContainer from '../ChartExplorerPageSearchContainer';
import ChartExplorerPageChartView from '../ChartExplorerPageChartView';
import styles from './ChartExplorerPageBody.module.css';

function ChartExplorerPageBody({
  deviceId,
  preference,
  loading,
  enabledZoom,
  enabledMarker,
  displayAxisTitle,
  displayActionAnnotation,
  displayUserAnnotation,
  displayDataLabel,
  displayMarker,
  onSelect,
  onCreate,
  onManage,
  onUpdate,
  onEditChart,
  onDeleteChart
}) {
  const context = useChartSet({
    enabledZoom,
    enabledMarker,
    displayAxisTitle,
    displayActionAnnotation,
    displayUserAnnotation,
    displayDataLabel,
    displayMarker
  });
  const [methods, { handleCreate, handleUpdate }] = useChartSetForm({
    preference,
    deviceId,
    onCreate,
    onUpdate,
    onDeleteChart
  });

  return (
    <DeviceChartSet.Provider {...context}>
      <FormProvider {...methods}>
        <div className={styles.root}>
          <ChartExplorerPageSearchContainer />
          <ChartExplorerPageChartView
            onSelect={onSelect}
            onCreate={handleCreate}
            onUpdate={handleUpdate}
            onManage={onManage}
            onEditChart={onEditChart}
            onDeleteChart={onDeleteChart}
            loading={loading}
            enabledMarker={enabledMarker}
          />
        </div>
      </FormProvider>
    </DeviceChartSet.Provider>
  );
}

export default ChartExplorerPageBody;
